import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faUser } from '@fortawesome/free-solid-svg-icons';
import { authService } from '../../Services';
import { authActions } from '../../Actions';
import jwtDecode from 'jwt-decode';

const Login = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search)

  const { from } = location.state || { from: { pathname: "/user/home" } };

  const auth = useSelector((state) => state.auth);
  useEffect(() => {  
    if (auth && auth.token) {
      return navigate(from);
    }

    if(params.get("confirm")) {
      setMsg("Thank you Your email verification success. Please Login to Apply for Fellowship");
    }
  }, []);

  const [input, setInput] = useState({
    username: '',
    password: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [msg, setMsg] = useState("");
  const { username, password } = input;

  const submitLogin = (from) => {
    authService.login(input).then(auth => {
      setSubmitted(false);
      if(auth.status == 0) {
        setMsg(auth.msg);
        return;
      }
      localStorage.setItem('token', auth.token);
      auth.user = jwtDecode(auth.token);
      dispatch(authActions.login(auth));
      navigate(from);
    });
  }

  const handleChange = (e) => {
    setMsg("");
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    submitLogin(from);
  }

  return (
    <>
      {/* <section id="page-banner" className="pt-10 pb-10 bg_cover" data-overlay="8" >
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="page-banner-cont">
                        <h4>Login</h4>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Login</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
      </section> */}

      <section className="pb-50">
        <div className="container">
          <div className="row">
            <div className='col-md-12'>
              <div className="contact-from offset-md-3 col-md-6">
                <fieldset className='border p-4 shadow-lg'>
                  <legend className='w-auto'>
                    <FontAwesomeIcon icon={faUser} className="pr-2 text-danger" />
                    Login Here
                  </legend>
                  <div className="main-form">
                    <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                      <div className="row">
                        <div className="col-md-12">
                          {msg && <p className="msg login text-danger mt-2">{msg}</p>}
                        </div>
                        <div className="col-md-12">
                          <div className="singel-form form-group">

                            <input name="username" type="text" placeholder="Your Email" value={username} onChange={handleChange} data-error="Email is required." required="required" />
                            <div className="help-block with-errors"></div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="singel-form form-group">
                            <input name="password" type="password" placeholder="Password" value={password} onChange={handleChange} data-error="Password is required." required="required" />
                            <div className="help-block with-errors"></div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="singel-form">
                            <button type="submit" className="main-btn disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Login</span>}
                            </button>
                            {/* &nbsp; &nbsp; <Link to={"/register"} className="btn btn-primary"><strong>Register here</strong></Link> */}
                            &nbsp; &nbsp; <br></br>
                          </div>
                          <Link to={"/forget-password"} className="mt-2"> Forgot Your Password?</Link>
                        </div>
                      </div>
                    </form>
                  </div>
                </fieldset>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;